import { Injectable } from '@angular/core';
import { SubskrypcjeFiltrModel } from '../models/subskrypcje-filtr.model';
import { KrsEntryService } from './krs-entry.service';
import { DataFilterServiceBase } from './data-filter-base.service';
import { DateHelper } from '../helpers/dateHelper';

@Injectable({
  providedIn: 'root'
})
export class DataFilterSubskrypcjeService extends DataFilterServiceBase<SubskrypcjeFiltrModel> {

  constructor(
    private krsEntryService: KrsEntryService
  ) {
    super();
  }

  saveFilter(name: string, filterWej: SubskrypcjeFiltrModel) {
    const filter = {...filterWej};
    if (filter.dataOstatniegoZdarzeniaDo) {
      filter.dataOstatniegoZdarzeniaDo = DateHelper.formatDate(filter.dataOstatniegoZdarzeniaDo, DateHelper.FORMAT_DATE);
    }
    if (filter.dataOstatniegoZdarzeniaOd) {
      filter.dataOstatniegoZdarzeniaOd = DateHelper.formatDate(filter.dataOstatniegoZdarzeniaOd, DateHelper.FORMAT_DATE);
    }
    if (filter.subskrypcjaDo) {
      filter.subskrypcjaDo = DateHelper.formatDate(filter.subskrypcjaDo, DateHelper.FORMAT_DATE);
    }
    if (filter.subskrypcjaOd) {
      filter.subskrypcjaOd = DateHelper.formatDate(filter.subskrypcjaOd, DateHelper.FORMAT_DATE);
    }
    if(filter.systemId) {
      filter.systemId = this.krsEntryService.normalizeKRS(filter.systemId);
    }
    super.saveFilter(name, filter);
  }
}
